/** How many preview items fit without overlapping adjacent list-row actions. */
export function computeFitVisibleCount({
  itemWidths,
  itemCount,
  maxVisible,
  gapPx,
  ellipsisWidth,
  availableWidth,
  reservePx = 4,
}: {
  itemWidths: readonly number[];
  itemCount: number;
  maxVisible: number;
  gapPx: number;
  ellipsisWidth: number;
  availableWidth: number;
  reservePx?: number;
}): number {
  const available = availableWidth - reservePx;
  if (available <= 0 || itemCount === 0) return 0;

  const cap = Math.min(itemCount, maxVisible);
  const widths = itemWidths.slice(0, cap);

  for (let visible = cap; visible >= 1; visible -= 1) {
    const hasHidden = itemCount > visible;
    let used = 0;
    for (let index = 0; index < visible; index += 1) {
      if (index > 0) used += gapPx;
      used += widths[index] ?? 0;
    }
    if (hasHidden) {
      if (visible > 0) used += gapPx;
      used += ellipsisWidth;
    }
    if (used <= available) return visible;
  }

  return Math.min(1, cap);
}
